import React from 'react'

import { useSurveyQueryData } from './useSurveyQueryData'

export const useSurveyQueryCustomerAttributeGroups = () => {
  const survey = useSurveyQueryData()

  return React.useMemo(
    () => survey?.customerAttributeGroups ?? [],
    [survey?.customerAttributeGroups],
  )
}
